export const PROFILE_TYPE_BUSINESS = {
  MORTGAGE: 'Mortgage Brokers'
}
